var map = {
	"./images/article1/chp1.jpg": 28,
	"./images/article1/chp1@2x.jpg": 29,
	"./images/article1/chp2.png": 30,
	"./images/article1/chp2@2x.png": 31,
	"./images/article1/end-cta.jpg": 32,
	"./images/article1/end-cta@2x.jpg": 33,
	"./images/article1/hero.jpg": 34,
	"./images/article1/hero@2x.jpg": 35,
	"./images/article1/pathfinder_awards_2024.png": 36,
	"./images/article1/percent1-1.svg": 37,
	"./images/article1/percent1-2.svg": 38,
	"./images/article1/percent1-3.svg": 39,
	"./images/article1/percent2-1.svg": 40,
	"./images/article1/percent2-2.svg": 41,
	"./images/article1/percent2-3.svg": 42,
	"./images/article1/percent2-4.svg": 43,
	"./images/article1/share.jpg": 44,
	"./images/article1/stamps.png": 45,
	"./images/article1/stamps@2x.png": 46,
	"./images/article1/stat-end-1.svg": 47,
	"./images/article1/stat-end-2.svg": 48,
	"./images/article1/stat-end-3.svg": 49,
	"./images/article1/stat1-1.svg": 50,
	"./images/article1/stat1-2.svg": 51,
	"./images/article1/stat1-3.svg": 52,
	"./images/article1/stat1-4.svg": 53,
	"./images/article1/stat2-1.svg": 54,
	"./images/article1/stat2-2.svg": 55,
	"./images/article1/stat2-3.svg": 56,
	"./images/article2/chp1.jpg": 57,
	"./images/article2/chp1@2x.jpg": 58,
	"./images/article2/chp2.png": 59,
	"./images/article2/chp2@2x.png": 60,
	"./images/article2/chp3.jpg": 61,
	"./images/article2/chp3@2x.jpg": 62,
	"./images/article2/hero.jpg": 63,
	"./images/article2/hero@2x.jpg": 64,
	"./images/article2/pathfinder_awards_2024.png": 65,
	"./images/article2/share.jpg": 66,
	"./images/article2/stamps.png": 67,
	"./images/article2/stamps@2x.png": 68,
	"./images/article2/stat1-1.svg": 69,
	"./images/article2/stat1-2.svg": 70,
	"./images/article2/stat1-3.svg": 71,
	"./images/article2/stat1-4.svg": 72,
	"./images/article2/stat2-1.svg": 73,
	"./images/article2/stat2-2.svg": 74,
	"./images/article2/stat2-3.svg": 75,
	"./images/article2/stat3-1.svg": 76,
	"./images/article2/stat3-2.svg": 77,
	"./images/article2/stat3-3.svg": 78,
	"./images/article2/stat4-1.svg": 79,
	"./images/article2/stat4-2.svg": 80,
	"./images/article2/stat5-1.svg": 81,
	"./images/article2/stat5-2.svg": 82,
	"./images/article2/stat5-3.svg": 83,
	"./images/article3/chp1.jpg": 84,
	"./images/article3/chp1@2x.jpg": 85,
	"./images/article3/chp2.png": 86,
	"./images/article3/chp2@2x.png": 87,
	"./images/article3/chp3.jpg": 88,
	"./images/article3/chp3@2x.jpg": 89,
	"./images/article3/hero.jpg": 90,
	"./images/article3/hero@2x.jpg": 91,
	"./images/article3/pathfinder_awards_2024.png": 92,
	"./images/article3/share.jpg": 93,
	"./images/article3/stamps.png": 94,
	"./images/article3/stamps@2x.png": 95,
	"./images/article3/stat1-1.svg": 96,
	"./images/article3/stat1-2.svg": 97,
	"./images/article3/stat1-3.svg": 98,
	"./images/article3/stat1-4.svg": 99,
	"./images/article3/stat2-1.svg": 100,
	"./images/article3/stat2-2.svg": 101,
	"./images/article3/stat2-3.svg": 102,
	"./images/article3/stat3-1.svg": 103,
	"./images/article3/stat3-2.svg": 104,
	"./images/article3/stat3-3.svg": 105,
	"./images/article3/stat3-4.svg": 106,
	"./images/article3/stat4-1.svg": 107,
	"./images/article3/stat4-2.svg": 108,
	"./images/article3/stat4-3.svg": 109,
	"./images/article3/stat4-4.svg": 110,
	"./images/article4/chp1.jpg": 111,
	"./images/article4/chp1@2x.jpg": 112,
	"./images/article4/chp3.jpg": 113,
	"./images/article4/chp3@2x.jpg": 114,
	"./images/article4/hero.jpg": 115,
	"./images/article4/hero@2x.jpg": 116,
	"./images/article4/pathfinder_awards_2024.png": 117,
	"./images/article4/share.jpg": 118,
	"./images/article4/stamps.png": 119,
	"./images/article4/stamps@2x.png": 120,
	"./images/article4/stat1-1.svg": 121,
	"./images/article4/stat1-2.svg": 122,
	"./images/article4/stat1-3.svg": 123,
	"./images/article4/stat2-1.svg": 124,
	"./images/article4/stat2-2.svg": 125,
	"./images/article4/stat2-3.svg": 126,
	"./images/article4/stat3-1.svg": 127,
	"./images/article4/stat3-2.svg": 128,
	"./images/article4/stat3-3.svg": 129,
	"./images/article4/stat4-1.svg": 130,
	"./images/article4/stat4-2.svg": 131,
	"./images/article4/stat4-3.svg": 132,
	"./images/article4/stat5-1.svg": 133,
	"./images/article4/stat5-2.svg": 134,
	"./images/article4/stat5-3.svg": 135,
	"./images/end-cta.jpg": 136,
	"./images/end-cta@2x.jpg": 137,
	"./images/logo-gb.png": 138,
	"./images/logo_cnn.svg": 139,
	"./images/pathfinder_awards_2024.png": 140,
	"./images/stamp-welcome.png": 141,
	"./images/stamp-welcome@2x.png": 142,
	"./images/stamps.png": 143,
	"./images/stamps@2x.png": 144,
	"./images/thumb-article-1.jpg": 145,
	"./images/thumb-article-1@2x.jpg": 146,
	"./images/thumb-article-2.jpg": 147,
	"./images/thumb-article-2@2x.jpg": 148,
	"./images/thumb-article-3.jpg": 149,
	"./images/thumb-article-3@2x.jpg": 150,
	"./images/thumb-article-4.jpg": 151,
	"./images/thumb-article-4@2x.jpg": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 252
// module chunks = 0